export default __webpack_public_path__ + "images/nydree-logo@2x.cd3e2cc10474a2b2cbd863ad31245f8f.png";